import { connect } from 'react-redux'
import BatchProposal from '../components/BatchProposal/BatchProposal'

const mapStateToProps = (state, ownProps) => {
  return {
    supplier: state.supplier
  }
}

const MappedContainer = connect(
  mapStateToProps
)(BatchProposal)

export default MappedContainer
